
export default {
  scrollToTop: true,
  async asyncData ({ $content, app: { i18n: { locale }, $seoMeta } }) {
    const category = await $content(locale, 'menus', 'the-babaaurums-classics').fetch()
    $seoMeta.update($seoMeta.page(category.seoMeta))

    return { category }
  }
}
